import React from "react"
import styled from "styled-components"
import Carousel from "react-bootstrap/Carousel"
import PageHeader from "./pageHeader"
import Img from "gatsby-image"
import backgroundImageSand from "../assets/images/sand_texture-bg.jpg"
import { Link } from "gatsby"
import AirbnbEmbed from "../components/airbnbEmbed"
import { Router } from "@reach/router"

const CabinInformation = ({ images, data, title }) => {
  return (
    <>
      <Carousel>
        {images.sliderImages.edges.map(image => (
          <Carousel.Item
            key={image.id}
            style={{ height: "80vh", maxHeight: "800px" }}
          >
            <Image
              fluid={image.node.childImageSharp.fluid}
              alt={image.node.base.split("_").join(" ").split(".")[0]}
            />
          </Carousel.Item>
        ))}
      </Carousel>
      <>
        {data.map(({ about, cabin, airbnb, amenities }, index) => (
          <>
            <PageHeader
              header={title}
              subHeader={"For the perfect Tofino vacation"}
            />
            <InfoContainer>
              <InfoWrapper>
                {cabin !== "Haidaway" && (
                  <AirBnbContainer>
                    <AirBnbWrapper key={index}>
                      <Router>
                        <AirbnbEmbed
                          path="/shipwreckcabin"
                          roomId="19529407"
                          shareId="d5a56336-2f2a-4db9-928c-203b61eb858b"
                          label="Shipwreck Cottage at Chesterman Beach"
                          width="450px"
                        />
                      </Router>
                      {/* HAIDAWAY HIDDEN (temporary): restore this router/embed when re-enabling Haidaway Cottage
                      <Router>
                        <AirbnbEmbed
                          path="/haidawaycottage"
                          roomId="20845861"
                          shareId="3b9a7230-e1f6-481d-a491-37e3d6f48ab5"
                          label="Haidaway Cottage at Chesterman Beach"
                          width="450px"
                        />
                      </Router>
                      */}
                    </AirBnbWrapper>
                    <AirBnBLink href={airbnb} target="_blank">
                      To view the {title} calendar click here
                    </AirBnBLink>
                  </AirBnbContainer>
                )}
                <AmenitiesWrapper>
                  <h3>{cabin} Amenities</h3>
                  <ul>
                    {amenities.map(amenity => (
                      <li key={amenity.id}>{amenity.amenity}</li>
                    ))}
                  </ul>
                </AmenitiesWrapper>
              </InfoWrapper>
              <AboutWrapper>
                <About>{about}</About>
              </AboutWrapper>
            </InfoContainer>
          </>
        ))}
      </>
    </>
  )
}

export default CabinInformation

const Image = styled(Img)`
  background: #000;
  height: 100%;
`

const InfoContainer = styled.div`
  padding: 5rem calc((100vw - 1200px) / 2);
  background: #fff;
  color: #000;
  background-image: url(${backgroundImageSand});
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  padding-bottom: 0;

  @media screen and (max-width: 868px) {
    grid-template-columns: 1fr;
    min-height: 500px;
  }
`

const InfoWrapper = styled.div`
  width: 100%;
  padding: 1rem;
  display: grid;
  justify-content: center;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 1rem;

  @media screen and (max-width: 868px) {
    grid-template-columns: 1fr;
    min-height: 500px;
  }
`

const AboutWrapper = styled.div`
  width: 100%;
  padding: 1rem;
  display: grid;
  grid-template-columns: 1fr;
  margin-bottom: 0;
`

const AirBnbContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;

  @media screen and (max-width: 868px) {
    padding: 0;
  }
`

const AirBnbWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 450px) {
    display: none;
  }
`

const AirBnBLink = styled(Link)`
  color: #1673b5;
  margin-top: 1rem;

  @media screen and (max-width: 450px) {
    margin: 0;
  }
`

const AmenitiesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 0;

  ul {
    margin-left: 2rem;
  }

  @media screen and (max-width: 868px) {
    padding: 0 1rem;
  }
`
const About = styled.p``
